var localeDaysOfWeek = [
        'Ne', 'Po', 'Ut', 'St', 'Št', 'Pi', 'So'
    ],
    localeMonthNames = [
        'Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December'
    ],
    openDays,
    closedDays;

function nearestFutureMinutes(interval, someMoment) {
    var roundedMinutes = Math.ceil(someMoment.minute() / interval) * interval;
    return someMoment.clone().minute(roundedMinutes).second(0);
}

function setAvailableTimes(startDate) {
    var day = startDate.day(),
        minDate = nearestFutureMinutes(15, moment()),
        maxDate = moment(),
        timePicker = $('.js-time-fake').data('daterangepicker');

    $(openDays).each(function() {
        if (day == this.day) {
            if (this.toHour <= this.fromHour || this.toHour === 0) {
                this.toHour = 23;
            }

            maxDate = maxDate.set({hour: this.toHour, minute: 0});
            minDate = minDate.set({hour: this.fromHour, minute: this.fromMinute});

            timePicker.setStartDate(minDate);

            return false;
        }
    });

    timePicker.minDate = minDate;
    timePicker.maxDate = maxDate;
}

$(function() {
    openDays = $('.js-form-reservation').data('open-days');
    closedDays = $('.js-form-reservation').data('closed-days');

    $('.js-date-fake').daterangepicker({
        minDate: moment(),
        singleDatePicker: true,
        locale: {
            format: 'DD.MM.YYYY',
            applyLabel: 'Potvrdiť',
            cancelLabel: 'Zrušiť',
            daysOfWeek: localeDaysOfWeek,
            monthNames: localeMonthNames,
            firstDay: 1
        },
        autoUpdateInput: false,
        buttonClasses: 'c-btn is-sm',
        applyButtonClasses: 'c-btn--primary',
        cancelButtonClasses: 'c-btn--delete',
        isInvalidDate: function(date) {
            var isClosed = true;

            $(openDays).each(function() {
                if (this.day == date.day()) {
                    isClosed = false;
                }
            });

            $(closedDays).each(function() {
                if (date.isSameOrAfter(this.from) && date.isSameOrBefore(this.to)) {
                    isClosed = true;
                }
            });

            return isClosed;
        }
    }).on('apply.daterangepicker', function(ev, picker) {
        setAvailableTimes(picker.startDate);
    }).on('apply.daterangepicker', function (e, picker) {
        picker.element.val(picker.startDate.format(picker.locale.format));
    });

    $('.js-time-fake').daterangepicker({
        singleDatePicker: true,
        timePicker: true,
        timePicker24Hour: true,
        autoUpdateInput: false,
        locale: {
            format: 'H:mm',
            applyLabel: 'Potvrdiť',
            cancelLabel: 'Zrušiť',
            daysOfWeek: localeDaysOfWeek,
            monthNames: localeMonthNames,
            firstDay: 1
        },
        timePickerIncrement: 15,
        buttonClasses: 'c-btn is-sm',
        applyButtonClasses: 'c-btn--primary',
        cancelButtonClasses: 'c-btn--delete'
    }).on('show.daterangepicker', function(e, picker) {
        $(picker.container[0]).find('.calendar-table').hide();
    }).on('apply.daterangepicker', function (e, picker) {
        picker.element.val(picker.startDate.format(picker.locale.format));
    });
});
